import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c95cd2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "network",
  "background-color": "yellow-65",
  size: "small"
}
const _hoisted_2 = { key: 1 }

import { useAppStore } from '@/popup/store/AppStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'TestnetLabel',
  setup(__props) {

const appStore = useAppStore()

return (_ctx: any,_cache: any) => {
  return (_unref(appStore).network?.chainId === 4201)
    ? (_openBlock(), _createElementBlock("lukso-tag", _hoisted_1, _toDisplayString(_ctx.$t('testnet.testnet')), 1 /* TEXT */))
    : (_openBlock(), _createElementBlock("span", _hoisted_2))
}
}

})